import React, { useState, Fragment } from "react";
import { Badge, Button, Input, Tooltip, Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import style from "./DocumentMenuBar.module.css";
import { ReactComponent as HeartSVG } from "../../../svgs/favorite_24dp_F20D0D.svg";
import { ReactComponent as HeartBorderSVG } from "../../../svgs/favorite_border_24dp_000.svg";
import { ReactComponent as BellSVG } from "../../../svgs/notifications_active_24dp_0D79F2.svg";
import { ReactComponent as ArrowLeft } from "./icons/ArrowLeft";
import { ReactComponent as ArrowRight } from "./icons/ArrowRight";
import { ReactComponent as BellOffSVG } from "../../../svgs/notifications_off_24dp_0D79F2.svg";
import { ReactComponent as ShareSVG } from "../../../svgs/share_24dp_0D79F2.svg";
import { ReactComponent as PackageSVG } from "../../../svgs/folder_zip_24dp_0D79F2.svg";
import { ReactComponent as PadlockOpenSVG } from "../../../svgs/lock_open_24dp_0D79F2.svg";
import { ReactComponent as PadlockClosedSVG } from "../../../svgs/lock_24dp_0D79F2.svg";
import { ReactComponent as ScrollSVG } from "../../../svgs/description_24dp_0D79F2.svg";
import { ReactComponent as WordBallonSVG } from "../../../svgs/chat_bubble_outline_24dp_0D79F2.svg";
import { ReactComponent as HyperlinkSVG } from "../../../svgs/link_24dp_0D79F2.svg";
import { ReactComponent as LabelSVG } from "../../../svgs/style_24dp_0D79F2.svg";
import { ReactComponent as PencilSVG } from "../../../svgs/pencil-svgrepo-com.svg";
import { ReactComponent as PencilSlashSVG } from "../../../svgs/pencil-slash-svgrepo-com.svg";
import { useProfile } from "../../../contexts/ProfileContext";
import { useEffect } from "react";
import { getProfile2 } from "../../../actions/ProfileAction";
import HttpClient from "../../../utils/HttpClient";
import { getTitle } from "../../../utils/documentUtils";
import { downloadZip, zipFiles} from "../../../utils/zipUtils";

function DocumentMenuBar({
    state,
    documents,
    metadata,
    url,
    strings,
    updateUrl,
    favoriteDoc,
    removeProfileValues,
    subscribeDoc,
    sendDocEmail,
    isLocked,
    handleLockDocument,
    pdfSize,
    changeSize,
    viewAudit,
    setViewAudit,
    existingComment,
    viewComments,
    setViewComments,
    isAnnotation,
    toggleAnnotation
}) {
    const [tooltipState, setTooltipState] = useState({
        prev: false, prevShown: false,
        next: false, nextShown: false,
        favorite: false, subscribe: false,
        share: false, export: false,
        lock: false,
        audit: false, comments: false,
        search: false, size: false, annotation: false
    });

    const handleTooltipState = (newState) => setTooltipState({ ...tooltipState, ...newState });
    const [searchResult, setSearchResult] = useState([]);

    const [search, setSearch] = useState(false);
    const [documentList, setDocumentList] = useState([]); //TODO: check if can remove this

    const { profile, setProfile } = useProfile();

    const httpClient = new HttpClient();

    const getNewDocument = step => {
        const new_findex = metadata._findex.value + step;
        if (new_findex >= 0 && new_findex < documents.length) {
            updateUrl(documents[new_findex]);
        }
    }

    const setFavoriteDocument = async () => {
        checkFavorite() ? await removeProfileValues({ type: "favorites", value: metadata.id.value }) : await favoriteDoc(metadata);
        setTimeout(() => {
            getProfile2().then((response) => {
                setProfile(response);
            });
        }, 500);
    }

    const setSubscribe = () => {
        checkSubscribed() ? removeProfileValues({ type: "subscriptions", value: metadata.id.value }) : subscribeDoc(metadata);
        setTimeout(() => {
            getProfile2().then((response) => {
                setProfile(response);
            });
        }, 500);
    }

    const handleShare = () => {
        alert("TODO: handleShare");
        sendDocEmail(metadata, "", url);
    }

    const checkFavorite = () => {
        if (profile) {
            return profile.favorites.find(fav => fav === metadata.id.value) ? true : false;
        }
        return false;
    }

    const checkSubscribed = () => {
        if (profile) {
            return profile.subscriptions.find(sub => sub === metadata.id.value) ? true : false;
        }
        return false;
    }


    useEffect(() => {
        setSearch(false);
        setSearchResult([]);
        httpClient.list(["*"]).then((response) => {
            setDocumentList(response);
        });
    }, []);

    const handleSearch = (e) => {
        const filteredList = state.documents.rawlist
            .filter(doc => {
                return doc.id.value !== metadata.id.value
                    && (getTitle(doc)?.toLowerCase().includes(e.target.value.toLowerCase())
                    || doc.id.value.toLowerCase().includes(e.target.value.toLowerCase())
                    || doc.Reference?.value?.toLowerCase().includes(e.target.value.toLowerCase())
                )
            })
        setSearchResult(filteredList)
        if (e.key === 'Enter') {
            setSearch(false);
        }
    }

    const setChildDocument = async (doc) => {
        setSearch(false);
        const srlNr = metadata.Reference?.value ?? metadata.Reference;
        if (metadata.Subdocuments?.value?.length > 0 && metadata.Subdocuments.value.includes(doc.Reference.value)) {
            httpClient.unlink(srlNr, doc.Reference.value);
        } else {
            httpClient.link(srlNr, doc.Reference.value);
        }
    }

    const handleZip = () => {
        zipFiles(getTitle(metadata), { metadata, url, title: getTitle(metadata) }).then(zip => {
            downloadZip(zip, getTitle(metadata));
        });
    }

    const handleChangeView = (isAudit) => {
        if (isAudit) {
            setViewAudit(v => !v);
            setViewComments(false);
        } else {
            setViewAudit(false);
            setViewComments(v => !v);
        }
    }

    const mimeType = metadata['Mimetype'].value;

    return (
        <Fragment>
            <div className={style.row}>
                <div className={style.favoriteColumn} id="fave">
                    <Button 
                        className={`${style.icon} d-flex align-items-center justify-content-center ${checkFavorite() ? 'text-danger' : ''}`}
                        onClick={setFavoriteDocument}
                        color="light"
                    >
                        {checkFavorite() ? <HeartSVG /> : <HeartBorderSVG />}
                    </Button>
                </div>
                <div className={style.titleColumn}>
                    <div className="d-flex align-items-center">
                        <span className="h4 mb-0">{getTitle(metadata)}</span>
                        {(viewAudit || viewComments) && (
                            <Badge color="info" pill className="ml-2" style={{ background: '#e9f2fe', color: '#0D79F2' }}>
                                {viewAudit ? 'Auditlog' : 'Comments'}
                            </Badge>
                        )}
                    </div>
                </div>
                <div className={style.stepColumn}>
                    <Tooltip target="prev" placement="top">
                        föregående dokument
                    </Tooltip>
                    <Button 
                        id="prev" 
                        className={`${style.icon} d-flex align-items-center justify-content-center`}
                        onClick={() => getNewDocument(-1)} 
                        color="light"
                        disabled={metadata._findex.value <= 0}
                    >
                        <ArrowLeft />
                    </Button>
                    <Tooltip target="next" placement="top">
                        nästa dokument
                    </Tooltip>
                    <Button 
                        id="next" 
                        className={`${style.icon} d-flex align-items-center justify-content-center ml-2`}
                        onClick={() => getNewDocument(1)} 
                        color="light"
                        disabled={metadata._findex.value >= documents.length - 1}
                    >
                        <ArrowRight />
                    </Button>
                </div>
                <div className={style.iconColumn}>
                {
 
                    }
                    <Button 
                        id="sub" 
                        className={`${style.icon} d-flex align-items-center justify-content-center ${checkSubscribed() ? 'text-primary' : ''}`}
                        onClick={setSubscribe}
                        color="light"
                        title={checkSubscribed() ? "Unsubscribe from changes" : "Subscribe to changes"}
                    >
                        {checkSubscribed() ? <BellSVG /> : <BellOffSVG />}
                    </Button>
                    <Button 
                        id="export"
                        className={`${style.icon} d-flex align-items-center justify-content-center`}
                        onClick={handleZip}
                        color="light"
                        title="Export document"
                    >
                        <PackageSVG />
                    </Button>
                    <Button 
                        id="audit" 
                        className={`${style.icon} d-flex align-items-center justify-content-center ${viewAudit ? 'bg-light' : ''}`}
                        onClick={() => handleChangeView(true)}
                        color="light"
                        title="View audit log"
                    >
                        <ScrollSVG />
                    </Button>
                    <Button 
                        id="comments" 
                        className={`${style.icon} d-flex align-items-center justify-content-center position-relative ${viewComments ? 'bg-light' : ''}`}
                        onClick={() => handleChangeView(false)}
                        color="light"
                        title="View comments"
                    >
                        <WordBallonSVG />
                        {existingComment && (
                            <Badge 
                                pill 
                                color="success" 
                                className="position-absolute" 
                                style={{ top: '0', right: '0', transform: 'translate(25%, -25%)' }}
                            >
                                !
                            </Badge>
                        )}
                    </Button>

                    {search && (
                        <Dropdown id="search" isOpen={search} toggle={() => setSearch(false)}>
                            <DropdownToggle tag="div">
                                <Input 
                                    type="text" 
                                    placeholder="Search documents..." 
                                    className={`${style.searchInput} shadow-none`} 
                                    onKeyUp={handleSearch}
                                    autoFocus
                                />
                            </DropdownToggle>
                            <DropdownMenu className="shadow-sm" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                {searchResult.length === 0 ? (
                                    <DropdownItem disabled>No documents found</DropdownItem>
                                ) : (
                                    searchResult.map(doc => (
                                        <DropdownItem 
                                            key={doc.serialNo}
                                            onClick={() => setChildDocument(doc)} 
                                            active={metadata?.Subdocuments?.value.includes(doc.serialNo)}
                                            className="d-flex align-items-center"
                                        >
                                            <i className="fas fa-file-alt mr-2"></i>
                                            {getTitle(doc)}
                                        </DropdownItem>
                                    ))
                                )}
                            </DropdownMenu>
                        </Dropdown>
                    )}
                    <Button 
                        id="changeSize" 
                        className={`${style.icon} d-flex align-items-center justify-content-center`}
                        onClick={changeSize}
                        color="light"
                    >
                        <LabelSVG />
                    </Button>
                </div>
            </div>
            <Tooltip
                isOpen={tooltipState.prev}
                placement="left"
                target="prev"
                toggle={() => { handleTooltipState({ prev: !tooltipState.prev && !tooltipState.prevShown, prevShown: true }); }}>
                {strings.TooltipPrev}
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.next}
                placement="right"
                target="next"
                toggle={() => { handleTooltipState({ next: !tooltipState.next && !tooltipState.nextShown, nextShown: true }); }}>
                {strings.TooltipNext}
            </Tooltip>

            <Tooltip
                isOpen={tooltipState.favorite}
                placement="right"
                target="fave"
                toggle={() => { handleTooltipState({ "favorite": !tooltipState.favorite }) }}>
                {checkFavorite() ? "Avmarkera som favorit" : "Markera som favorit"}
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.subscribe}
                placement="right"
                target="sub"
                toggle={() => { handleTooltipState({ subscribe: !tooltipState.subscribe }) }}>
                {checkSubscribed() ? "Avsluta prenumerera på ändringar" : "Prenumerera på ändringar"}
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.export}
                placement="right"
                target="export"
                toggle={() => { handleTooltipState({ export: !tooltipState.export }) }}>
                Exportera dokumentet
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.comments}
                placement="left"
                target="comments"
                toggle={() => { handleTooltipState({ comments: !tooltipState.comments }) }}>
                Visa kommentarer
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.size}
                placement="right"
                target="changeSize"
                toggle={() => { handleTooltipState({ size: !tooltipState.size }) }}>
                {pdfSize === 12 ? strings.TooltipShowMetadata : strings.TooltipHideMetadata}
            </Tooltip>
        </Fragment>
    )
}

export default DocumentMenuBar;

/*
                <div className={style.stepColumn}>
                    <Tooltip target="prev" placement="top">
                        föregående dokument
                    </Tooltip>
                    <Button 
                        id="prev" 
                        className={`${style.icon} d-flex align-items-center justify-content-center`}
                        onClick={() => getNewDocument(-1)} 
                        color="light"
                        disabled={metadata._findex.value <= 0}
                    >
                        <ArrowLeft />
                    </Button>
                    <Tooltip target="next" placement="top">
                        nästa dokument
                    </Tooltip>
                    <Button 
                        id="next" 
                        className={`${style.icon} d-flex align-items-center justify-content-center ml-2`}
                        onClick={() => getNewDocument(1)} 
                        color="light"
                        disabled={metadata._findex.value >= documents.length - 1}
                    >
                        <ArrowRight />
                    </Button>
                </div>
                <div className={style.iconColumn}>
                {
                        mimeType === "application/pdf" ?
                            (<div id="annotation">
                                {isAnnotation ? <PencilSlashSVG className={style.icon} onClick={() => toggleAnnotation()} /> : <PencilSVG className={style.icon} onClick={() => toggleAnnotation()} />}
                            </div>)  : <div id="annotation"></div>
                    }
                    <Button 
                        id="sub" 
                        className={`${style.icon} d-flex align-items-center justify-content-center ${checkSubscribed() ? 'text-primary' : ''}`}
                        onClick={setSubscribe}
                        color="light"
                        title={checkSubscribed() ? "Unsubscribe from changes" : "Subscribe to changes"}
                    >
                        {checkSubscribed() ? <BellSVG /> : <BellOffSVG />}
                    </Button>
                    <Button 
                        id="share" 
                        className={`${style.icon} d-flex align-items-center justify-content-center`}
                        onClick={handleShare}
                        color="light"
                        title="Share document"
                    >
                        <ShareSVG />
                    </Button>
                    <Button 
                        id="export" 
                        className={`${style.icon} d-flex align-items-center justify-content-center`}
                        onClick={handleZip}
                        color="light"
                        title="Export document"
                    >
                        <PackageSVG />
                    </Button>
                    <Button 
                        id="lock" 
                        className={`${style.icon} d-flex align-items-center justify-content-center`}
                        onClick={() => handleLockDocument(!isLocked)}
                        color="light"
                        title={isLocked ? "Unlock document" : "Lock document"}
                    >
                        {isLocked ? <PadlockClosedSVG /> : <PadlockOpenSVG />}
                    </Button>
                    <Button 
                        id="audit" 
                        className={`${style.icon} d-flex align-items-center justify-content-center ${viewAudit ? 'bg-light' : ''}`}
                        onClick={() => handleChangeView(true)}
                        color="light"
                        title="View audit log"
                    >
                        <ScrollSVG />
                    </Button>
                    <Button 
                        id="comments" 
                        className={`${style.icon} d-flex align-items-center justify-content-center position-relative ${viewComments ? 'bg-light' : ''}`}
                        onClick={() => handleChangeView(false)}
                        color="light"
                        title="View comments"
                    >
                        <WordBallonSVG />
                        {existingComment && (
                            <Badge 
                                pill 
                                color="success" 
                                className="position-absolute" 
                                style={{ top: '0', right: '0', transform: 'translate(25%, -25%)' }}
                            >
                                !
                            </Badge>
                        )}
                    </Button>
                    {!search && (
                        <Button 
                            id="search" 
                            className={`${style.icon} d-flex align-items-center justify-content-center`}
                            onClick={() => setSearch(true)}
                            color="light"
                            title="Link documents"
                        >
                            <HyperlinkSVG />
                        </Button>
                    )}
                    {search && (
                        <Dropdown id="search" isOpen={search} toggle={() => setSearch(false)}>
                            <DropdownToggle tag="div">
                                <Input 
                                    type="text" 
                                    placeholder="Search documents..." 
                                    className={`${style.searchInput} shadow-none`} 
                                    onKeyUp={handleSearch}
                                    autoFocus
                                />
                            </DropdownToggle>
                            <DropdownMenu className="shadow-sm" style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                {searchResult.length === 0 ? (
                                    <DropdownItem disabled>No documents found</DropdownItem>
                                ) : (
                                    searchResult.map(doc => (
                                        <DropdownItem 
                                            key={doc.serialNo}
                                            onClick={() => setChildDocument(doc)} 
                                            active={metadata?.Subdocuments?.value.includes(doc.serialNo)}
                                            className="d-flex align-items-center"
                                        >
                                            <i className="fas fa-file-alt mr-2"></i>
                                            {getTitle(doc)}
                                        </DropdownItem>
                                    ))
                                )}
                            </DropdownMenu>
                        </Dropdown>
                    )}
                    <Button 
                        id="changeSize" 
                        className={`${style.icon} d-flex align-items-center justify-content-center`}
                        onClick={changeSize}
                        color="light"
                    >
                        <LabelSVG />
                    </Button>
                </div>
            </div>
            <Tooltip
                isOpen={tooltipState.prev}
                placement="left"
                target="prev"
                toggle={() => { handleTooltipState({ prev: !tooltipState.prev && !tooltipState.prevShown, prevShown: true }); }}>
                {strings.TooltipPrev}
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.next}
                placement="right"
                target="next"
                toggle={() => { handleTooltipState({ next: !tooltipState.next && !tooltipState.nextShown, nextShown: true }); }}>
                {strings.TooltipNext}
            </Tooltip>

            <Tooltip
                isOpen={tooltipState.favorite}
                placement="right"
                target="fave"
                toggle={() => { handleTooltipState({ "favorite": !tooltipState.favorite }) }}>
                {checkFavorite() ? "Avmarkera som favorit" : "Markera som favorit"}
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.subscribe}
                placement="right"
                target="sub"
                toggle={() => { handleTooltipState({ subscribe: !tooltipState.subscribe }) }}>
                {checkSubscribed() ? "Avsluta prenumerera på ändringar" : "Prenumerera på ändringar"}
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.share}
                placement="right"
                target="share"
                toggle={() => { handleTooltipState({ share: !tooltipState.share }) }}>
                Dela länk till dokumentet
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.export}
                placement="right"
                target="export"
                toggle={() => { handleTooltipState({ export: !tooltipState.export }) }}>
                Exportera dokumentet
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.annotation}
                placement="right"
                target="annotation"
                toggle={() => { handleTooltipState({ annotation: !tooltipState.annotation }) }}>
                {isAnnotation ? "Utan annoteringar" : "Med annoteringar"}
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.lock}
                placement="right"
                target="lock"
                toggle={() => { handleTooltipState({ lock: !tooltipState.lock }) }}>
                {isLocked ? "Lås upp dokumentet" : "Lås dokumentet"}
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.audit}
                placement="left"
                target="audit"
                toggle={() => { handleTooltipState({ audit: !tooltipState.audit }) }}>
                Visa ändringslogg
            </Tooltip>
            <Tooltip
                isOpen={tooltipState.comments}
                placement="left"
                target="comments"
                toggle={() => { handleTooltipState({ comments: !tooltipState.comments }) }}>
                Visa kommentarer
            </Tooltip>
            {!search && <Tooltip
                isOpen={tooltipState.search}
                placement="left"
                target="search"
                toggle={() => { handleTooltipState({ search: !tooltipState.search }) }}>
                Sätt underdokument
            </Tooltip>}
            <Tooltip
                isOpen={tooltipState.size}
                placement="right"
                target="changeSize"
                toggle={() => { handleTooltipState({ size: !tooltipState.size }) }}>
                {pdfSize === 12 ? strings.TooltipShowMetadata : strings.TooltipHideMetadata}
            </Tooltip>
        </Fragment>
    )
*/